import React from 'react';
import { Link } from 'react-router-dom';
import './Homepage.css';

const Homepage = () => {
  return (
    <div className="homepage">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">
              <span className="title-highlight">Your site.</span>{' '}
              <span className="title-normal">Your vision.</span>{' '}
              <span className="title-highlight">Your way.</span>
            </h1>
            <p className="hero-subtitle">
              Over 30 years of experience developing sites from residential to commercial applications in the Greater Boston Area.
            </p>
            <div className="hero-cta">
              <Link to="/contact" className="btn-primary">
                Get Your Proposal
              </Link>
              <Link to="/services" className="btn-secondary">
                Our Services
              </Link>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-image-container">
              <img 
                src="/Construction_images/construction-engineer-stands-control-work-construction-site.jpg" 
                alt="TB Construction Site Work"
                className="hero-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Why Choose TB Construction?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <img src="/icons/TB_Icons_Hardhat.png" alt="30+ Years Experience" className="feature-icon" />
              <h3>30+ Years Experience</h3>
              <p>Three decades of proven expertise in construction and site development</p>
            </div>
            <div className="feature-card">
              <img src="/icons/TB_Icons_Consturction Worker.png" alt="Residential & Commercial" className="feature-icon" />
              <h3>Residential & Commercial</h3>
              <p>From single-family homes to large commercial developments</p>
            </div>
            <div className="feature-card">
              <img src="/icons/TB_Icons_Measuring Tape.png" alt="Ready to Propose" className="feature-icon" />
              <h3>Ready to Propose</h3>
              <p>We're ready to provide proposals, schedules, and pricing for your approved plans</p>
            </div>
            <div className="feature-card">
              <img src="/icons/TB_Icons_Hardhat.png" alt="Digital Meetings" className="feature-icon" />
              <h3>Digital Meetings</h3>
              <p>Schedule a digital meeting or phone call to discuss your project</p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process">
        <div className="container">
          <h2 className="section-title">How We Work</h2>
          <div className="process-flow">
            <div className="process-step">
              <div className="step-card">
                <div className="step-number">1</div>
                <h3>You Provide Plans</h3>
                <p>Clients provide approved architectural construction documents that are fully approved by the building department and/or local zoning board</p>
              </div>
              <div className="step-arrow">
                <img src="/icons/TB_Icons_Arrow-Right.png" alt="Next step" className="arrow-icon" />
              </div>
            </div>
            <div className="process-step">
              <div className="step-card">
                <div className="step-number">2</div>
                <h3>We Analyze</h3>
                <p>Our team reviews your plans and site requirements to understand the scope of work</p>
              </div>
              <div className="step-arrow">
                <img src="/icons/TB_Icons_Arrow-Right.png" alt="Next step" className="arrow-icon" />
              </div>
            </div>
            <div className="process-step">
              <div className="step-card">
                <div className="step-number">3</div>
                <h3>We Propose</h3>
                <p>We provide detailed proposals, schedules, and competitive pricing for your project</p>
              </div>
              <div className="step-arrow">
                <img src="/icons/TB_Icons_Arrow-Right.png" alt="Next step" className="arrow-icon" />
              </div>
            </div>
            <div className="process-step">
              <div className="step-card">
                <div className="step-number">4</div>
                <h3>We Execute</h3>
                <p>From site clearing to final landscaping, we handle everything outside</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Call us today for a digital meeting or phone call to discuss your project</p>
          <Link to="/contact" className="btn-primary btn-large">
            Contact Us Today
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Homepage;

